import styled, { keyframes } from 'styled-components';

export interface WhatsAppDotsProps {
  count?: number;
  background?: string;
  color?: string;
}
export const WhatsAppDots = ({
  background,
  color,
  count = 3
}: WhatsAppDotsProps) => (
  <Component _backgroundColor={background}>
    <ComponentInner>
      {Array.from({ length: count }, (_, index) => `0.${index}s`).map(
        (delay) => (
          <Dot key={delay} delay={delay} _color={color} />
        )
      )}
    </ComponentInner>
  </Component>
);

const animation = keyframes`
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.75;
  }
`;

const Component = styled.div<{ _backgroundColor?: string }>`
  position: absolute;
  top: inherit;
  left: inherit;
  background-color: ${({ _backgroundColor }) => _backgroundColor};
  width: 53px;
  height: 32px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease all;
  z-index: 1;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.15);
`;

const ComponentInner = styled.div`
  position: relative;
  display: flex;
`;

const Dot = styled.div<{ delay: string; _color?: string }>`
  height: 5px;
  width: 5px;
  margin: 0 2px;
  background-color: ${({ _color }) => _color};
  border-radius: 50%;
  display: inline-block !important;
  position: relative;
  animation: ${animation} 1.2s linear infinite;
  animation-delay: ${({ delay }) => delay};
`;
